var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upq-cart-badge"},[_c('i',{staticClass:"fas fa-2x fa-shopping-cart text-black align-middle"}),_vm._v(" "),_c('span',{staticClass:"ml-2 text-black"},[_vm._v(_vm._s(this.$root.$data.itemCount)+" items")])])
}
var staticRenderFns = []

export { render, staticRenderFns }